import { useMutation, useQueryClient } from "react-query";
import { designControlsApi } from "../../api/designControls";
import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export const useDeleteReview = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const queryClient = useQueryClient();
  const { showToast } = useToastProvider();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (reviewId: string) =>
      designControlsApi.deleteReview(companyId, productId, reviewId),
    onSuccess: async () => {
      await queryClient.invalidateQueries([
        "REVIEW_LIST",
        companyId,
        productId,
      ]);
      showToast({
        title: t("reviews.notifications.deleteSuccess.title"),
        description: t("reviews.notifications.deleteSuccess.description"),
        status: "success",
      });
      navigate("../change-control");
    },
    onError: (error: any) => {
      showToast({
        title: t("reviews.notifications.deleteError.title"),
        description:
          error.status === 400
            ? t("reviews.notifications.deleteErrorWithElements")
            : t("reviews.notifications.deleteError.description"),
        status: "error",
      });
    },
  });
};
